import _ from 'lodash';
import './App.css';
import { NotFoundPage } from './pages/common/not-found-page';
import { LoginPage } from './pages/auth/login_page';
import { CompanyGrowthPage } from './pages/company/company_growth_page';
import { CompanyTeamGrowthPage } from './pages/company/company_team_growth_page';
import { Routes, Route } from 'react-router-dom';
import { CompanyTalentPage } from './pages/company/company_talent_page';
import { UniverseChartPage } from './pages/universe/universe_page';
import { CompanyTenurePage } from './pages/company/company_tenure_page';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiServrUrl, getGoogleAnalyticsId } from './utils/utils';
import { CompanySearchPage } from './pages/company/company_search_page';
import { CompanySearchAndCreateUniversePage } from './pages/company/company_search_and_create_universe_page';
import { RegisterUserPage } from './pages/auth/register_user_page';
import { VerifyEmailPage } from './pages/auth/verify_email_page';
import { HomePage } from './pages/common/home_page';
import { ForgotPasswordPage } from './pages/auth/forgot-password-page';
import { ResetPasswordPage } from './pages/auth/reset-password-page';
import { BugReportPage } from './pages/common/bug_report_page';
import { UniverseEditPage } from './pages/universe/universe_edit_page';
import { BizDevReportPage } from './pages/report/bizdev_report_page';
import { BizDevReportKfPage } from './pages/report/bizdev_report_kf_page';
import { CompanyGeoPage } from './pages/company/company_geo_page';

function usePageViews() {
    let location = useLocation();

    useEffect(() => {
        // Assuming gtag is available as a global function
        if (typeof window.gtag === 'function') {
			const gAnalyticsId = getGoogleAnalyticsId();
            window.gtag('config', gAnalyticsId, {
                'page_path': location.pathname + location.search
            });
        }
    }, [location]);
}

function App() {
	usePageViews();

	return (
		<div>
			<Routes>
				{/* <Route exact path="/" element={<HomePage />} />
				<Route path="/home" element={<HomePage />} />
				<Route path="/report-bug" element={<BugReportPage />} />
				<Route path="/report/preview" element={<BizDevReportPage />} />
				<Route path="report/kf/preview" element={<BizDevReportKfPage />} />
				<Route path="*" element={<NotFoundPage />} />

				<Route path='/register' element={<RegisterUserPage />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/verify-email" element={<VerifyEmailPage />} />
				<Route path="/forgot-password" element={<ForgotPasswordPage />} />
				<Route path="/reset-password" element={<ResetPasswordPage />} />

				<Route path="/universe/summary" element={<UniverseChartPage />} />
				<Route path="/universe/company/search" element={<CompanySearchAndCreateUniversePage />} />
				<Route path="/universe/edit" element={<UniverseEditPage />} /> */}

				<Route path="*" element={<NotFoundPage />} />

				{/* <Route path="/company/search" element={<CompanySearchAndCreateUniversePage />} /> */}
				<Route path="/company/growth" element={<CompanyGrowthPage />} />
				<Route path="/company/team/growth" element={<CompanyTeamGrowthPage />} />
				<Route path="/company/talent" element={<CompanyTalentPage />} />
				<Route path="/company/tenure" element={<CompanyTenurePage />} />
				<Route path="/company/geo" element={<CompanyGeoPage />} />
				
			</Routes>
		</div>
	);
}

export default App;